<template>

        <div class="tooltip-custom tooltip-custom--close" v-if="!localStorage">
            <button type="button" class="tooltip-close" @click.prevent="setLocalStorageCookie">
                <span aria-hidden="true">&times;</span>
            </button>
            {{$store.getters.t('cookies_banner_line1')}}
            {{$store.getters.t('cookies_banner_line2')}}
        </div>

</template>

<script>
export default {
    name: "Cookies",
    data(){
        return{
            localStorage: false
        }
    },
    mounted(){
        this.getLocalStorageCookie()
    },
    methods:{
        setLocalStorageCookie(){
            localStorage.setItem('Cookie', 'true');
            this.localStorage = true
        },
        getLocalStorageCookie(){

            if(localStorage.getItem('Cookie')) this.localStorage = localStorage.getItem('Cookie')

        }
    }
}
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
    opacity: 0;
}
</style>
